import { useQuery } from "react-query";
import { getSafeMakes } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useSafeMakes = () => {
  const { data, isLoading, refetch } = useQuery("GetSafeMakes", getSafeMakes, {
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, refetch };
};
